export const mixins = {
    data() {
        return {
            companyProfileList: [
                // 关于我们
                { id: 3004, name: "公司介绍", title: this.$t("companyProfile.companyProfile"), path: "/companyProfile/3004" },
                // { id: 3013, name: "组织架构", title: this.$t("companyProfile.companyStructure"), path: "/companyProfile/3013" },
                // { id: 3005, name: "企业文化", title: this.$t("companyProfile.corporateCulture"), path: "/companyProfile/3005" },
                { id: 3006, name: "企业荣誉", title: this.$t("companyProfile.corporateHonor"), path: "/companyProfile/3006" },
                { id: 3007, name: "发展历程", title: this.$t("companyProfile.development"), path: "/companyProfile/3007" },
                {
                    id: 3008,
                    name: "我们的客户",
                    title: this.$t("companyProfile.customers"),
                    path: "/companyProfile/3008",
                },
                { id: 3009, name: "合作伙伴", title: this.$t("companyProfile.partners"), path: "/companyProfile/3009" },
                {
                    id: 3010,
                    name: "南航集团介绍",
                    title: this.$t("companyProfile.chinaSouthernAirlines"),
                    path: "/companyProfile/3010",
                },
            ],
            newsList: [
                // 新闻
                {
                    id: "3000",
                    name: "公司新闻",
                    title: this.$t("news.companyNews"),
                    path: "/news_list?id=3000",
                },
                {
                    id: "3001",
                    name: "行业动态",
                    title: this.$t("news.industryNews"),
                    path: "/news_list?id=3001",
                },
                {
                    id: "3014",
                    name: "信息公开",
                    title: this.$t("news.informationDisclosure"),
                    path: "/news_list?id=3014",
                },
            ],
            productCenterList: [
                // 产品与服务
                {
                    name: "产品与服务",
                    title: this.$t("route.ProductCenter"),
                    path: "/product",
                },
                // {name:'理论产品',title:'理论产品',path:'/productCenter/productCard/1'},
                // {name:'模拟机培训',title:'模拟机培训',path:'/productCenter/productCard/2'},
                // {name:'训练产品',title:'训练产品',path:'/productCenter/productCard/3'},
                // {name:'航空科普研学',title:'航空科普研学',path:'/productCenter/productCard/4'},
            ],

            pilotServiceList: [
                // 客户服务
                { name: "客户服务", title: this.$t("route.Pilot"), path: "/pilotService" },
                // {
                //     name: "模拟机计划查询",
                //     title: this.$t("pilotService.simulatorPlan"),
                //     path: "/pilotService/planQuery",
                // },
                // {
                //     name: "理论计划查询",
                //     title: this.$t("pilotService.TheoreticalPlan"),
                //     path: "/pilotService/planQuery/second",
                // },
                // {
                //   name: "交通指引",
                //   title: "交通指引",
                //   path: "/pilotService/trafficGuidance",
                // },
                // {
                //   name: "失物招领",
                //   title: "失物招领",
                //   path: "/pilotService/lostFound",
                // },
                // {
                //     name: "问卷调查",
                //     title: this.$t("pilotService.QuestionnaireInvestigation"),
                //     path: "/pilotService/questionnaireInvestigation",
                // },
                // {
                //     name: "训练须知",
                //     title: this.$t("pilotService.Training"),
                //     path: "/pilotService/articleCenter/3011",
                // },
                // {
                //   name: "园区服务建议",
                //   title: "园区服务建议",
                //   path: "/pilotService/articleCenter/3012",
                // },
                { name: "在线学习系统", title: this.$t("pilotService.OnlineLearningSystem"), path: "https://xylms.zhftc.com" },
            ],
            contactList: [
                // 联系我们
                {
                    name: "联系方式",
                    title: this.$t("contactUs.contactInformation"),
                    path: "/ContactUs",
                },
                {
                    name: "人才招聘",
                    title: this.$t("contactUs.talentRecruitment"),
                    path: "/ContactUs/talentRecruitment",
                },
                { name: "南航集团", title: this.$t("contactUs.chinaSouthernAirlinesGroup"), path: "https://www.csairgroup.cn" },
            ],
            legalAndMap: [
                { title: this.$t("legalAndMap.legalStatement"), path: "/legalStatement" },
                { title: this.$t("legalAndMap.siteMap"), path: "/legalStatement/siteMap" },
            ],
        };
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {},
};